"use strict";

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var THREE = _interopRequireWildcard(require("three"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Flip =
/*#__PURE__*/
function (_Component) {
  _inherits(Flip, _Component);

  function Flip() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Flip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Flip)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "animate", function () {
      _this.delta = _this.clock.getDelta();
      requestAnimationFrame(_this.animate);

      _this.evolveSmoke();

      _this.mesh.rotation.x += 0.005;
      _this.mesh.rotation.y += 0.01;
      _this.cubeSineDriver += 0.01;
      _this.mesh.position.z = 100 + Math.sin(_this.cubeSineDriver) * 500;

      _this.renderer.render(_this.scene, _this.camera);
    });

    _defineProperty(_assertThisInitialized(_this), "evolveSmoke", function () {
      var sp = _this.smokeParticles.length;

      while (sp--) {
        _this.smokeParticles[sp].rotation.z += _this.delta * 0.2;
      }
    });

    return _this;
  }

  _createClass(Flip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var width = this.mount.clientWidth;
      var height = this.mount.clientHeight; //Three.js setup

      this.clock = new THREE.Clock();
      this.renderer = new THREE.WebGLRenderer();
      this.renderer.setSize(width, height);
      this.scene = new THREE.Scene();
      this.camera = new THREE.PerspectiveCamera(75, width / height, 1, 10000);
      this.camera.position.z = 1000;
      this.scene.add(this.camera);
      var geometry = new THREE.BoxGeometry(200, 200, 200);
      var material = new THREE.MeshLambertMaterial({
        color: 0xaa6666,
        wireframe: false
      });
      this.mesh = new THREE.Mesh(geometry, material);
      this.cubeSineDriver = 0;
      var textGeo = new THREE.PlaneGeometry(300, 300);
      var textTexture = new THREE.TextureLoader().load(this.props.src, function (textTexture) {
        var textMaterial = new THREE.MeshLambertMaterial({
          color: 0x00ffff,
          opacity: _this2.props.opacity,
          map: textTexture,
          transparent: true,
          blending: THREE.AdditiveBlending
        });
        var text = new THREE.Mesh(textGeo, textMaterial);
        text.position.z = 800;

        _this2.scene.add(text);
      }, undefined, function (err) {
        console.log("load failed.");
        console.log(err);
      });
      var light = new THREE.DirectionalLight(0xffffff, 0.5);
      light.position.set(-1, 0, 1);
      this.scene.add(light);
      this.smokeParticles = [];
      var smokeTexture = new THREE.TextureLoader().load(this.props.smokeSrc, function (smokeTexture) {
        var smokeMaterial = new THREE.MeshLambertMaterial({
          color: 0x00dddd,
          map: smokeTexture,
          opacity: _this2.props.smokeOpacity,
          transparent: true
        });
        var smokeGeo = new THREE.PlaneGeometry(300, 300);

        for (var p = 0; p < 150; p++) {
          var particle = new THREE.Mesh(smokeGeo, smokeMaterial);
          particle.position.set(Math.random() * 500 - 250, Math.random() * 500 - 250, Math.random() * 1000 - 100);
          particle.rotation.z = Math.random() * 360;

          _this2.scene.add(particle);

          _this2.smokeParticles.push(particle);
        }
      }, undefined, function (err) {
        console.log("load failed.");
        console.log(err);
      });
      this.mount.appendChild(this.renderer.domElement); // remember these initial values
      // let tanFOV = Math.tan(((Math.PI / 180) * this.camera.fov) / 2);
      // let windowHeight = height;

      this.animate(this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cancelAnimationFrame(this.frameId);
      this.mount.removeChild(this.renderer.domElement);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react["default"].createElement("div", {
        style: {
          height: this.props.height || "100vh",
          width: this.props.width || "100vw",
          margin: "0"
        },
        ref: function ref(mount) {
          _this3.mount = mount;
        }
      });
    }
  }]);

  return Flip;
}(_react.Component);

exports["default"] = Flip;